<div class="panel {{shadowStyled}} {{marginBottonStyled}}">
    <ng-content select="app-panel-header"></ng-content>
    <ng-content></ng-content>
</div>
